import { TagSeverity } from 'src/app/shared/ui/tag/tag.model';

/**
 * Stored on the event, tracking its assigned order; Cancelled is terminal and survives later order
 * transitions. Values match BE EventStatus.
 */
export enum EventStatus {
	NotCompleted = 0,
	Assigned = 1,
	InProgress = 2,
	Completed = 3,
	Cancelled = 4,
}

// Single source for the event status color coding: the status tag and the calendar both map through here.
export const eventStatusSeverity = (status: EventStatus): TagSeverity => {
	switch (status) {
		case EventStatus.NotCompleted:
			return 'secondary';
		case EventStatus.Assigned:
			return 'warn';
		case EventStatus.InProgress:
			return 'success';
		case EventStatus.Completed:
			return 'contrast';
		case EventStatus.Cancelled:
			return 'danger';
	}
};
